import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
    return (
        <div className="min-h-screen bg-cream grain grid place-items-center px-4" data-testid="cancel-page">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="max-w-lg w-full rounded-[2rem] bg-white border border-sage/15 shadow-2xl shadow-sage/10 p-8 sm:p-12 text-center"
            >
                <motion.span
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: "spring", stiffness: 260, damping: 18, delay: 0.2 }}
                    className="mx-auto w-20 h-20 rounded-full bg-sand/70 text-ink/70 grid place-items-center"
                >
                    <XCircle size={36} strokeWidth={1.6} />
                </motion.span>
                <h1 className="mt-8 font-serif text-3xl sm:text-4xl text-ink">Paiement annulé</h1>
                <p className="mt-4 text-base text-[#4A5550] leading-relaxed">
                    Aucun montant n’a été débité. Vous pouvez reprendre votre commande
                    à tout moment — votre dos vous attend.
                </p>
                <div className="mt-10 flex flex-col sm:flex-row justify-center gap-3">
                    <Link
                        data-testid="cancel-back-button"
                        to="/"
                        className="inline-flex justify-center rounded-full bg-sage hover:bg-sage-hover text-cream font-semibold px-8 py-4 transition-all duration-300 hover:scale-[1.02]"
                    >
                        Retour à la boutique
                    </Link>
                    <Link
                        data-testid="cancel-offers-button"
                        to="/"
                        className="inline-flex justify-center items-center rounded-full border border-sage/25 px-8 py-4 text-sm font-semibold text-sage hover:bg-sage-soft transition-colors"
                    >
                        Revoir les offres
                    </Link>
                </div>
            </motion.div>
        </div>
    );
}
